import React, {
  Component,
  PropTypes
} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { } from '../actions/';
import BrowseIdeasPage from '../components/BrowseIdeas/BrowseIdeasPage';
import { INITIATIVE_TYPE, CIP_TYPE } from '../constants';
import { fetchCipIdeasAction, fetchCipGroupsAction, fetchInitiatives, fetchInitiativeTypesAction, setInitiativeFilter } from '../actions/';


class BrowseIdeasContainer extends Component {
  render() {
    const ideaType = (this.props.params && this.props.params.ideaType) ? this.props.params.ideaType : INITIATIVE_TYPE;
    const { actions } = this.props;
    const { cipIdeaPage } = this.props;
    const { initiativePage } = this.props;
    const { initiativeTypes } = this.props;
    const myOwnIdea = false;
    const { cipGroups } = this.props;
    const { authInfo } = this.props;
    const { locale } = this.props;
    const { initiativeFilter } = this.props;

    return <BrowseIdeasPage
      locale={locale}
      authInfo={authInfo}
      myOwnIdea={myOwnIdea}
      initiativeTypes={initiativeTypes}
      actions={actions}
      ideaType={ideaType}
      cipGroups={cipGroups}
      cipIdeaPage={cipIdeaPage}
      initiativePage={initiativePage}
      initiativeFilter={initiativeFilter}
    />;
  }
}

BrowseIdeasContainer.propTypes = {
  actions: PropTypes.shape({})
};

function mapStateToProps(state) {
  const props = {
    cipIdeaPage: state.currentCipIdeaPage,
    cipGroups: state.cipGroups,
    initiativePage: state.currentInitiativePage,
    initiativeTypes: state.initiativeTypes,
    authInfo: state.authInfo,
    locale: state.locale,
    initiativeFilter: state.initiativeFilter
  };
  return props;
}

function mapDispatchToProps(dispatch) {
  const actions = { fetchCipIdeasAction, fetchCipGroupsAction, fetchInitiatives, fetchInitiativeTypesAction, setInitiativeFilter };
  const actionMap = { actions: bindActionCreators(actions, dispatch) };
  return actionMap;
}

export default connect(mapStateToProps, mapDispatchToProps)(BrowseIdeasContainer);



// WEBPACK FOOTER //
// ./containers/BrowseIdeasContainer.js